import { SVGProps } from "react";

const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "8"}
    height={props.height || "14"}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.750047 0.75C0.750047 0.75 6.74999 5.16893 6.75 6.75005C6.75001 8.33116 0.75 12.75 0.75 12.75"
      stroke={props.color ? props.color : "#AFAFAE"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ChevronRight;
